/**
 * Блок "Время работы"
 *
 * @param {string} workingTime - параметр из JSON
 */
const getMapWorkingTime = workingTime => {
    return `<p class="ylist-working-time">
        <svg class="ylist-icon-clock icon icon--clock"><use xlink:href="#icon-clock"></use></svg>
        ${workingTime}
    </p>`;
};

/**
 * Блок "Номер телефона"
 *
 * @param {string} phone - параметр из JSON
 */
const getMapPhoneNumber = phone => {
    if (!phone) return '';

    let phoneString;
    const makePhoneLink = phoneNumber => {
        return `<a class="ylist-nowrap" href="tel:${phoneNumber.replace(/[ '()-]+/g, '')}">${phoneNumber}</a>`;
    };

    // Если строка, то одна ссылка
    if (typeof phone === 'string') {
        phoneString = makePhoneLink(phone);
    }

    // Если массив строк, то несколько ссылок
    if (Array.isArray(phone)) {
        phoneString = phone.map(phoneItem => makePhoneLink(phoneItem)).join(', ');
    }

    return `<p class="ylist-phone">${phoneString}</p>`;
};

export { getMapWorkingTime, getMapPhoneNumber };
